export default {
  //API
  apiBaseHost: 'https://api.farmakom.io',
  apiBasePath: '/v1/frontend',
  devApiBaseHost: 'http://localhost:8081',

  // CDN
  cdnBaseHost: 'https://cdn.farmakom.io',

  // SSR
  useSSR: true,

  // DEV - for prod leave everything commented
  // hostname: 'farmacia-rossi.ecomm-v3.farmakom.io',
  // hostname: 'farmacia-bianchi.ecomm-v3.farmakom.io',
  // hostname: 'farmacia-verdi.ecomm-v3.farmakom.io',
  // hostname: 'farmacia33.it',
  // hostname: 'farmaciadepasquale.it',
  // hostname: 'ieocosmetica.it',
  // hostname: 'pharmaonline24.it',
  // hostname: 'latuafarmacia.org',
  // hostname: 'farmaciadelmonaco.it',
  // hostname: 'farmacia015.it',
  // useDevApi: true,
};
